import { makeStyles } from '@mui/styles';
import React from 'react';

import ChangesTable from '../../ControlChangesIcon/ChangesTable';

const useStyles = makeStyles({
  root: {
    padding: '10px 0',
  },
});

const ExpandableComponent = ({ row: { id } }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ChangesTable id={id} isInsideExpandableRow />
    </div>
  );
};

export default ExpandableComponent;
